import * as React from 'react';
import * as agui from 'arm-gui/dist/controls';
import { Utils, DateFormatter, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';


class LimitiAccessiBox extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[LimitiAccessiBox.jsx] ';
        this.state = {
            searchAccessiCombo: [
                { label: 'Ultima settimana', value: 7 },
                { label: 'Ieri', value: 1 },
                { label: 'Oggi', value: 0 },                
                { label: 'Ultimo mese', value: 30 },
                { label: 'Ultimo trimestre ', value: 90 },
                { label: 'Ultimo semestre', value: 180 },
                { label: 'Ultimo anno', value: 365 },
                { label: 'Tutti', value: -1 },

            ],
        };

    }

    render() {
        console.log(this.componentName + "render");


        return (
           
                <div className=" col col-sm-2 col-md-2 col-lg-2s" >
                    <agui.ASelectV4 
                        id={this.props.id}
                        required={false}
                        value={this.state.searchAccessiCombo}
                        label={this.props.label}
                        items={this.state.searchAccessiCombo}
                        onChange={this.props.inputChangeHandler}
                        valueKey="value"
                        labelKey="label"
                        addEmptyOption={false} />
                </div>
            



        );
    }

}
export default LimitiAccessiBox;